const data = {
  id: "taxation",
  title: "Taxation",
  intro: "Corporations get exemptions, abatements, and Tax Increment Financing (TIF) districts. You pay full grocery tax. Who actually carries the tax burden in Huntsville — and who decided it should work this way?",
  tabs: [
    {
      id: "overview",
      label: "Overview",
      visual: { type: "placeholder", title: "In-progress visual", description: "This section is being expanded now. The shell is in place so the page loads cleanly while content is rebuilt." },
      issues: [
        {
          id: "in_progress",
          label: "In Progress",
          title: "Taxation is being rebuilt",
          summary: "This section is being expanded now using the approved module structure.",
          details: "The page shell, routing, and component system are in place. This module is visible so the site feels complete, but the full issue set and action tooling are still being populated.",
          decoder: {
            whatsHappening: "This module is being rebuilt into the new structure.",
            connections: "The old mixed page/data system is being replaced with a cleaner module-based architecture.",
            benefits: "The benefit is a more stable, maintainable site that is easier to expand and update.",
            impact: "Right now, the impact is limited because this section is still being populated.",
            actions: {
              intro: "This section is still being built out. Check back as more issue cards and action paths are added.",
              contacts: [],
              meetings: [],
              paths: [],
              actions: []
            }
          }
        }
      ],
      trail: []
    },
    {
      id: "corporate_exemptions",
      label: "Corporate Exemptions",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "grocery_sales_tax",
      label: "Grocery & Sales Tax",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "local_vs_state",
      label: "Local vs. State",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
